import { IThamSoHeThongChucNangActionTypes } from "../../action-types/category/IThamSoHeThongChucNangActions";
import { IThamSoHeThongChucNangReducer } from "../../reducer-model/category/IThamSoHeThongChucNangReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";


const iniState: IThamSoHeThongChucNangReducer = {
    status: eReducerStatusBase.is_not_initialization,
    thamSoHeThongChucNangs: []
};

export const thamSoHeThongChucNangReducer = (state : IThamSoHeThongChucNangReducer = iniState, action: IThamSoHeThongChucNangActionTypes): IThamSoHeThongChucNangReducer => {
    switch (action.type) {
        case "THAM_SO_HE_THONG_CHUC_NANG_SELECT_BY_CHUC_NANG":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_SELECT_BY_CHUC_NANG_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thamSoHeThongChucNangs: action.payload,
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_SELECT_BY_CHUC_NANG_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_UPDATE_ACTIVE_STATUS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_UPDATE_ACTIVE_STATUS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thamSoHeThongChucNangs: state.thamSoHeThongChucNangs.map(item => 
                    item.id === action.payload.id ? { ...item, active: action.payload.active } : item
                ),
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_UPDATE_ACTIVE_STATUS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_UPDATE_THAM_SO_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_UPDATE_THAM_SO_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                thamSoHeThongChucNangs: state.thamSoHeThongChucNangs.map(item => 
                    item.id === action.payload.id ? { ...item, gia_tri: action.payload.gia_tri, active: action.payload.active } : item
                ),
            };
        case "THAM_SO_HE_THONG_CHUC_NANG_UPDATE_THAM_SO_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        
        default:
            return state;
    }
};